import { Pipe, PipeTransform } from '@angular/core';

import { isObject } from 'lodash';

//TODO: We have disabled checking in templates, we need to check the types
@Pipe({
  name: 'merge',
  standalone: true,
})
export class MergePipe implements PipeTransform {
  transform(...values: unknown[]): unknown[] | object {
    const cleared = values.filter(Boolean);
    return cleared.every(Array.isArray) ? cleared.flat() : cleared.every(isObject) ? Object.assign({}, ...cleared) : cleared;
  }
}
